import { useDeleteCategory } from '@/api/glow-up/glow-up.hooks';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Category } from '@repo/types/src/glow-up';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

type DeleteCategoryProps = {
  category: Category;
  refetch: () => void;
};

export const DeleteCategory = ({ category, refetch }: DeleteCategoryProps) => {
  const mutation = useDeleteCategory();
  const [open, setOpen] = useState(false);

  const handleDelete = () => {
    mutation.mutate(category.id, {
      onSuccess: () => {
        setOpen(false);
        refetch();
        toast.success(
          `La catégorie ${category.title} a été supprimée avec succès!`,
          {
            duration: 3000,
          },
        );
      },
      onError: () => {
        toast.error(
          `Erreur lors de la suppression de la catégorie ${category.title}`,
          {
            duration: 3000,
          },
        );
      },
    });
  };

  const isLoading = mutation.isPending;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive" size="sm" disabled={isLoading}>
          <Trash2 size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-center">
            Supprimer la catégorie
          </DialogTitle>
          <DialogDescription className="text-center">
            Êtes-vous sûr de vouloir supprimer la catégorie "{category.title}" ?
            Cette action supprimera également tous les exercices associés et est
            irréversible.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="ghost" disabled={isLoading}>
              Annuler
            </Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? 'Suppression...' : 'Supprimer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
